import { NavLink } from 'react-router-dom'
import { Home, MessageSquare, MessageCircle, CalendarCheck, ShoppingBag, User } from 'lucide-react'
import { useVerticalUI } from '@/lib/verticalUI'

export default function MobileBottomNav() {
  const { profile } = useVerticalUI()
  const isAppointmentsVertical = profile.nav.showAppointments && !profile.nav.showOrders

  const primaryTransactionItem = isAppointmentsVertical
    ? {
        name: profile.nav.primaryNavLabel,
        path: '/app/appointments',
        icon: CalendarCheck,
        ariaLabel: `Ver ${profile.nav.primaryNavLabel.toLowerCase()}`,
      }
    : {
        name: profile.nav.primaryNavLabel,
        path: '/app/orders',
        icon: ShoppingBag,
        ariaLabel: `Ver ${profile.nav.primaryNavLabel.toLowerCase()}`,
      }

  const navItems = [
    {
      name: 'Inicio',
      path: '/app/dashboard',
      icon: Home,
      ariaLabel: 'Ir al dashboard principal',
    },
    {
      name: 'Chats',
      path: '/app/conversations',
      icon: MessageSquare,
      ariaLabel: 'Ver conversaciones',
    },
    {
      name: 'Canales',
      path: '/app/instances',
      icon: MessageCircle,
      ariaLabel: 'Gestionar canales de mensajería',
    },
    primaryTransactionItem,
    {
      name: 'Perfil',
      path: '/app/profile',
      icon: User,
      ariaLabel: 'Ver mi perfil',
    },
  ]

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-white border-t border-gray-200 shadow-top safe-area-bottom"
      role="navigation"
      aria-label="Navegación principal móvil"
    >
      <div className="flex justify-around items-center h-14 sm:h-16 max-w-lg mx-auto px-1">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            aria-label={item.ariaLabel}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 h-full min-w-0 px-1 py-1.5 
               transition-all duration-200 relative tap-highlight-none touch-target
               focus-visible:ring-2 focus-visible:ring-green-600 focus-visible:ring-inset rounded-lg
               ${isActive
                  ? 'text-green-600'
                  : 'text-gray-500 hover:text-gray-700 active:text-green-600 active:scale-95'
               }`
            }
          >
            {({ isActive }) => (
              <>
                {/* Indicador activo */}
                {isActive && (
                  <span 
                    className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-1 bg-green-600 rounded-b-full" 
                    aria-hidden="true"
                  />
                )}
                <item.icon
                  className={`w-5 h-5 sm:w-6 sm:h-6 mb-0.5 transition-transform ${
                    isActive ? 'stroke-2 scale-110' : 'stroke-[1.5]'
                  }`}
                  aria-hidden="true"
                />
                <span 
                  className={`text-[10px] sm:text-xs font-medium truncate w-full text-center select-none ${
                    isActive ? 'font-semibold' : ''
                  }`}
                >
                  {item.name}
                </span>
                {/* Screen reader: indicar estado activo */}
                {isActive && <span className="sr-only">(página actual)</span>}
              </>
            )}
          </NavLink>
        ))}
      </div>
      {/* Espaciador para safe area en iOS */}
      <div className="h-safe-area-bottom bg-white" aria-hidden="true" />
    </nav>
  )
}
